define('app/views/lazy_view',['app/setup'], function(takhfifan) {

  takhfifan.WindowView = Backbone.View.extend({
    events: {
      'scroll': 'notify',
      'click': 'windowClick'
    },

    notify: function(e) {
      takhfifan.eventHub.trigger('window:scroll');
    },

    windowClick: function(e) {
      takhfifan.eventHub.trigger('window:click', e);
    }
  });

  takhfifan.LazyView = Backbone.View.extend({

    initialize: function(options) {
      this.options = options;
      this.addRowNumber();
      this.lazyLoad();
      var _this = this;
      $(window).on('scroll', function(){
        _this.lazyLoad();
      });
      $(window).on('resize', function(){
        _this.lazyLoad();
      });

      takhfifan.eventHub.on('lazyLoad:notify', function() {
        _this.lazyLoad();
      });

      takhfifan.eventHub.on('lazyLoad:load', function() {
        _this.addRowNumber();
        _this.lazyLoad();
      }, this);
    },

    isOnScreen: function(el) {
      var win = $(window);
      var viewport = {
      	top: win.scrollTop()
      };
      viewport.bottom = viewport.top + win.height();
      var bounds = el.offset();
      bounds.bottom = bounds.top + el.outerHeight();
      return (!(viewport.bottom < bounds.top || viewport.top > bounds.bottom));
    },

    addRowNumber: function() {
      var imagesElements = this.$el.find('img.lazy');
      var lastItemTopOffset = imagesElements.eq(0).offset().top;
      var counter = 1;
      imagesElements.each(function(i,v) {
        if(lastItemTopOffset == $(v).offset().top){
          $(v).parents('.deal').attr('data-lazy-row', counter);
          $(v).parents('.deal').addClass('lazy-row');
        }
        else{
          counter += 1;
          $(v).parents('.deal').attr('data-lazy-row', counter);
          $(v).parents('.deal').addClass('lazy-row');
        }
        lastItemTopOffset = $(v).offset().top;
      });
    },

    lazyLoad: _.throttle(function(){
      var dealElement = this.$el.find('.deal');
      if(dealElement.hasClass('lazy-row')){
        this.loadImagesOfDeals(this.findVisibleDeals(), true);
      }
    },500),

    findVisibleDeals: function() {
      var _this = this;
      return this.$el.find('.deal:visible:not(.lazy-loaded)').filter(function(i, v) {
        return _this.isOnScreen($(v));
      });
    },

    loadImagesOfDeals: function(deals, loadNextRow) {
      var _dealsLen = $(deals).length,
          _this = this;
      var dealsDetails = [];
      $(deals).each(function(i,v){
        if(!($(v).hasClass('lazy-loaded'))){
          var dealImage = $(v).find('img.lazy');
          var dealImageSource = $(v).find('source.lazy');
          dealImage.prop('src', dealImage.data('src'));
          dealImageSource.prop('srcset', dealImageSource.data('srcset'));
          $(v).addClass('lazy-loaded');
          dealsDetails.push($(v).data('details'));
        }
        if (loadNextRow && i === _dealsLen - 1) {
          var nextRowNumber = parseInt($(v).data('lazy-row'),10) + 1,
              nextRowDeals = $('.deal[data-lazy-row="'+ nextRowNumber +'"]');

          _this.loadImagesOfDeals(nextRowDeals, false);
        }
      });
      if(dealsDetails.length){
        takhfifan.eventHub.trigger('ga:productImpression', dealsDetails);
      }
    }

  });
});

